import Vue from 'vue'
import Loading from './loading'

const Mask = Vue.extend(Loading)

const handleLoading = (el, binding) => {
	if (binding.value) {
		el.instance.show()
		if (binding.modifiers.disabling) {
			el.setAttribute('disabled', '')
		}
	} else {
		el.instance.hide()
		if (binding.modifiers.disabling) {
			el.removeAttribute('disabled')
		}
	}
}

export default {
	name: 'loading',
	inserted (el, binding) {
		const mask = new Mask({
			el: document.createElement('div')
		})

		el.instance = mask
		el.mask = mask.$el

		if (binding.modifiers.fullScreen) {
			// TODO: improve fullscreen mode for pointing to single instance
			el.instance.setFullscreen(true)
			document.body.appendChild(el.mask)
		} else {
			if (binding.modifiers.circle) {
				el.instance.setCircle(true)
			}
			el.style.position = 'relative'
			el.appendChild(el.mask)
		}

		handleLoading(el, binding)
	},
	update (el, binding) {
		handleLoading(el, binding)
	},
	unbind (el) {
		el.instance && el.instance.$destroy()
	}
}
